// alert('111');


(function ($, Drupal) {
  Drupal.behaviors.topMenuScroll = {
    attach(context, settings) {
      const $context = $(context);
      once(
        'topMenuScroll',
        '.page > nav.navbar',
        context,
      ).forEach((navbar) => {
        const $navbar = $(navbar);
        const scrolledClass = 'scrolled';
        // $navbar.css('margin-top', $('body').css('padding-top'));
        $(window).scroll(function () {
          if ($(window).scrollTop() == 0) {
            $navbar.removeClass(scrolledClass);
          }
          else {
            $navbar.addClass(scrolledClass);
          }
          // $navbar.css('margin-top', $('body').css('padding-top'));
        })
      });
    },
  };
})(jQuery, Drupal);
